<template>
    <div class="AddTestQuestions">
        <div class="page-header">
            <el-page-header @back="goBack" content="我的题库 - 创建问题">
            </el-page-header>
        </div>
        <div class="body">
            <div class="aside scroll-body">
                <el-tabs v-model="activeTabsName" type="border-card">
                <el-tab-pane label="题型" name="first">
                    <QuestionTypeList 
                        :typeObj="typeObj"
                        @commonTopic="commonTopic"
                        :type="'ks'"
                    ></QuestionTypeList>
                </el-tab-pane>
                <el-tab-pane label="大纲" name="third">
                    <QuestionOutline 
                        ref="questionOutline"
                        :type="'ks'"
                        :paper="paper"
                        :activeQuesIndex="activeQuesIndex"
                        @goAnchor="goAnchor"
                    ></QuestionOutline>
                </el-tab-pane>
                </el-tabs>
            </div>
            <div class="ques-content">
                <div class="no-content" v-show="paper.questionsList && paper.questionsList.length == 0">点击左侧题型，添加题目到此处</div>
                <ExamQuesTemplate :isBank="true" ref="examQuesTemplate" :paper="paper" @submit="submit"></ExamQuesTemplate>
            </div>
        </div>
    </div>
</template>

<script>
import QuestionTypeList from "@/components/examQuesTemplate/questionTypeList.vue"
import ExamQuesTemplate from "@/components/examQuesTemplate/index.vue"
import { mapState } from "vuex"
import Paper from "@/components/examQuesTemplate/js/Paper.js"
import QuestionOutline from "@/components/examQuesTemplate/questionOutline.vue"
export default {
    name: 'AddTestQuestions',
    components: {
        QuestionTypeList,
        ExamQuesTemplate,
        QuestionOutline
    },
    props: {
        bankId: {
            type: String,
            default: ''
        }
    },
    data() {
        return {
            activeTabsName: 'first',
            // collapseVisible: ['1', '2', '3', '4'],
            typeObj: [
                {
                questionsTypeName: '常用考试题型',
                questionTypeList:[
                    {
                        label: "单选题",
                        questionsTypeId: 100,
                        icon: 'zxwj-icon-danxuan_xuanzhong'
                    },
                    {
                        label: "多选题",
                        questionsTypeId: 101,
                        icon: 'zxwj-icon-duoxuanxuanzhong'
                    },
                    {
                        label: "判断题",
                        questionsTypeId: 102,
                        icon: 'zxwj-icon-icon-'
                    },
                    {
                        label: "填空题",
                        questionsTypeId: 204,
                        icon: 'zxwj-icon-tiankongti'
                    },
                    {
                        label: "简答题",
                        questionsTypeId: 206,
                        icon: 'zxwj-icon-jiandati'
                    },
                ]
                },{
                questionsTypeName: '更多题型',
                questionTypeList:[
                    {
                        label: "上传文件",
                        questionsTypeId: 210,
                        icon: 'zxwj-icon-yunshangchuan'
                    },
                    {
                        label: "多项填空",
                        questionsTypeId: 207,
                        icon: 'zxwj-icon-tiankongti'
                    },
                    {
                        label: "横向填空",
                        questionsTypeId: 208,
                        icon: 'zxwj-icon-jiandati'
                    },
                    {
                        label: "绘图题",
                        questionsTypeId: 209,
                        icon: 'zxwj-icon-huituguanlixinxi'
                    },
                    // {
                    //   label: "上传图片",
                    //   questionsTypeId: 211,
                    //   icon: 'icon-shangchuantupian'
                    // },
                ]
                },{
                questionsTypeName: '分页设置',
                questionTypeList:[
                    {
                        label: "一题一页",
                        questionsTypeId: 404,
                        icon: 'zxwj-icon-xiti'
                    },
                    {
                        label: "分页",
                        questionsTypeId: 402,
                        icon: 'zxwj-icon-chaifenyemian'
                    },
                    {
                        label: "段落说明",
                        questionsTypeId: 401,
                        icon: 'zxwj-icon-duanla'
                    },
                ]
                },
            ],
            paper: {},
            operationTimer: '',
            countDown: 60,
            createTime: '',
			activeQuesIndex: -1, // 当前大纲选中的试题index 包含所有题型
        }
    },
    computed:{
		...mapState(['examQuestionTypeArr']),
        id() {
            return this.$route.query.bankId
        },
        title() {
            return this.$route.query.title
        },
        depict() {
            return this.$route.query.depict
        },
        isEdit() {
            return this.$route.query.isEdit
        },
        questionBank() {
            // 1: 我的题库 2：系统题库
            return this.$route.query.questionBank
        },
	},
    watch:{
        'paper.questionsList': {
            handler(vnew, vold) {
                let total = 0
                let quesCount = 0
                let pageCount = 0
                if (this.paper.questionsList.length > 0) {
                total = this.paper.questionsList.reduce((total, item) => {
                    if(item.score) {
                    return total + item.score
                    } else {
                    return total
                    }
                }, 0)
                this.paper.questionsList.forEach((info) =>{
                    // console.log(info)
                    if (info.questionsTypeId == 402 || info.questionsTypeId == 404) {
                    pageCount++
                    }
                    if (this.examQuestionTypeArr.indexOf(info.questionsTypeId) != -1) {       
                    quesCount++
                    }
                })
                this.$refs.examQuesTemplate.changeSort()
                this.paper.pageCount = pageCount
                this.paper.quesCount = quesCount
                this.paper.totalScore = total
                } else {
                this.paper.totalScore = 0
                }
            },
            deep: true
        },
        'paper': {
            handler(vnew, vold) {
                // console.log('更新了')
                clearTimeout(this.operationTimer)
                this.timer()
                this.countDown = 60
            },
            deep: true
        },
        activeTabsName(newval, oldval) {
			this.$refs.questionOutline.queryOutline = '';
			this.$refs.questionOutline.list = JSON.parse(JSON.stringify(this.paper.questionsList));
		},
    },
    created() {
        // console.log(`题库id: ${this.id}`)
        // 初始化paper
        this.initFunction()
        if (this.isEdit) {
            // 加载试题
            this.getQuestion() 
        }
    },
    mounted() {
        // 获取创建时间
        this.createTime = this.$functions.GetDate()
    },
    methods: {
        // 锚点定位
        goAnchor(aname, qid, index) {
            this.$nextTick(() => {
                let selector = `div[name=${aname}]`;
                var anchor = this.$el.querySelector(selector);
                if (anchor) {
                    anchor.scrollIntoView({ block: 'center', behavior: 'smooth' });
                }
            });
            console.log(qid)
            if (qid) {
                    this.activeQuesIndex = this.paper.questionsList.findIndex(info => info.qid == qid)
                    this.setEditIndex(this.activeQuesIndex)
            } else {
                this.activeQuesIndex = -1
            }
		},
		setEditIndex(index) {
			this.paper.cancleEdit();
			if (index != undefined) {
				this.paper.questionsList[index].isedit = true;
			}
		},
        getQuestion() {
            let that = this;
            let data = {
                id: this.id,
            }
            let params = {
                that: this,
                url: `${this.$config.service.examBankGetQuess}?id=${this.id}`,
                method: "GET",
                cb(res) {
                    // console.log(res)
                    if (res.code == '0') {
                        let paper = JSON.parse(res.resultBody.paperjson)
                        
                        for(let key in paper) {
                           that.paper[key] = paper[key];
                        }
                        that.paper.questionsList = paper.questionsList.map((info) => {
                            if (that.$functions.isJSON(info)){
                                return JSON.parse(info)
                            }
                            return info
                        })
                    }
                },
            };
            this.$util.request(params);
        },
        submit(state) {
            // console.log('提交')
            this.paper.questionsList.forEach(info => {
                if (info.questionsTypeId == 100 && info.scoringType == 2) {
                    info.oidScoreArr = []
                    info.scoreArr.forEach((item, index) => {
                    if (typeof(item) == 'undefined') info.scoreArr[index] = 0
                    info.optionList.forEach((el, elindex) => {
                        if (index == elindex) {
                        // console.log(index)
                        info.oidScoreArr[index] = `${el.oid}@${info.scoreArr[index]}`
                        }
                    })
                    })
                }
            })
            // console.log(this.paper)
            // console.log('触发')
            clearTimeout(this.operationTimer)
            let paperJson = JSON.parse(JSON.stringify(this.paper))
            paperJson.questionsList.forEach((info) => {
            // console.log(info)
            if(info.questionsTypeId == 101 && info.answer.length>0) {
                info.answer = info.answer.join(';')
            }else if(info.questionsTypeId == 101 && info.answer.length == 0) {
                info.answer = ''
            }
            })
            let that = this;
            let data = {
                id: this.id,
                paperjson: JSON.stringify(paperJson),
                createTime: this.createTime,
                updateTime: this.$functions.GetDate(),
                bankType: 0
            }
            let params = {
                that: this,
                url: `${this.$config.service.examBankAddQuess}`,
                method: "post",
                data: data,
                cb(res) {
                    if (res.code == '0') {
                        if (state) {
                            that.goBack()
                            that.$message({
                                message: res.message,
                                type: 'success'
                            });
                        }
                    } else {
                        that.$message.error(res.message)
                    }
                },
            };
            this.$util.request(params);
            
        },
        initFunction() {
            //默认创建对象
            this.paper = new Paper()
            this.paper.title = this.title
            this.paper.depict = this.depict
        },
        timer() {
            this.operationTimer = setTimeout(() => {
                // console.log(this.countDown)
                if (this.countDown > 0){
                this.countDown--
                this.timer()
                }else {
                this.submit()
                }
            }, 1000);
        },
        commonTopic(item) {
            // console.log(item)
            if(item.questionsTypeId == 211) {
                this.$message({
                message: '此功能正待开发',
                type: 'warning'
                })
            } else {
                
                // //取消正在编辑的问题
                this.paper.cancleEdit();
                //新插入的问题设置为编辑状态
                if (item.questionsTypeId == 600) {
                    this.paper.createQuestion(item.questionsTypeId, this.selectIndex, item.infoName, this.id);
                } else {
                    this.paper.createQuestion(item.questionsTypeId, this.selectIndex, '', this.id);
                }
            }
        },
        goBack() {
            this.$router.go(-1)
        },
    },
    beforeRouteLeave (to, from, next) {
        // console.log('路由跳转')
        this.submit()
        clearTimeout(this.operationTimer)
        next()
    },
}
</script>

<style lang="scss" scoped>

.AddTestQuestions{
    height: 100%;
    background-color: #fff !important;
    .page-header{
        padding: 20px;
        background-color: rgb(255, 255, 255);
    }
    .form-box{ 
        width: 600px;
        margin: 40px auto 0 auto;
        .title{
            font-size: 16px;
            margin: 0 0 40px 30px;
        }
    }
    .body{
        display: flex;
        .aside{ 
            height: calc(100vh - 64px);
            width: 290px;
            background-color: rgb(255, 255, 255);
            box-sizing: border-box;
            // padding: 0 10px;
            overflow-y: auto;
            margin: 0 20px;
        }
        .ques-content{
            // width: 100%;
            display: block;
            flex: 1;
            flex-basis: auto;
            box-sizing: border-box;
            padding: 0 20px 80px 0;
            overflow-y: auto;
            height: calc(100vh - 64px);
            /deep/.finish-edit{
                right: auto;
                width: calc(100% - 314px);
            }
        }
        .no-content{
            width: 100%;
            background: #fff;
            padding: 120px 0;
            text-align: center;    
            margin-bottom: 5px;
            box-sizing: border-box;
            font-size: 16px;
            box-shadow: 0 2px 8px 0 rgba(0, 0, 0, .16);
        }
    }
}
</style>